// extracted by mini-css-extract-plugin
export var PostPreview = "post-preview-module--PostPreview--27dSA";
export var PostPreview__img = "post-preview-module--PostPreview__img--2yaP_";
export var PostPreview__title = "post-preview-module--PostPreview__title--2FwYE";
export var PostPreview__title_inverse = "post-preview-module--PostPreview__title_inverse--cRqtW";